<template>
    <div class="t-container page">
        <div class="page-heading" role="heading">
            <h1 class="page-heading__header">
                Scan Report
            </h1>
        </div>

      <div class="t-w-full t-text-md t-bg-white t-shadow-md t-rounded t-mt-10">
            <el-row type="flex" style="margin-top: 10px">
            <el-col :lg="24" :xl="22">
                <el-card>
                    <div slot="header" class="clearfix">
                        <h3>Scan Report</h3>
                    </div>
                    <div class="mb-3">
                        <line-chart :chart-data="scanGraphDataSet" :options="scanGraphOptions" v-if="!scanGraphLoading"></line-chart>
                    </div>
                    <div class="mt-3">
                        <bar-chart :chart-data="contractorGraphDataSet" :options="contractorGraphOptions" v-if="!contractorGraphLoading"></bar-chart>
                    </div>
                    <div class="mt-5" v-if="businessId != 259">
                        <user-scans-table></user-scans-table>
                    </div>
                </el-card>
            </el-col>
        </el-row>
      </div>
    </div>
</template>

<script>
    import LineChart from '../../components/charts/LineChart.js'
    import BarChart from '../../components/charts/BarChart.js'
    import UserScansTable from '../../components/tables/UserScans'

    export default {
        name: 'QrReport',
        props:  ['businessId'],
        data() {
            return {
                scanGraphDataSet: null,
                scanGraphOptions: [],
                scanGraphLoading: true,
                contractorGraphDataSet: null,
                contractorGraphOptions: [],
                contractorGraphLoading: true,
            }
        },
        components: {
            LineChart,
            BarChart,
            UserScansTable
        },
        mounted(){
            if(this.businessId == 259){
                this.getContractorData();
                this.getParcelineScanData();
            }else{
                this.getCarrierScanData();
            }
        },
        methods: {
            getCarrierScanData(){
                this.scanGraphLoading = true;
                axios.get("scan-report/scanData")
                    .then(response => {
                        this.scanGraphDataSet = {
                            labels: response.data.freightScansLabels,
                            datasets: [
                                {
                                    label: 'Total Scans',
                                    data: response.data.freightScansData,
                                    backgroundColor: 'rgb(0, 116, 217, .3)'
                                }
                            ],
                        }

                        this.scanGraphOptions = {
                            title: {
                                display: true,
                                text: 'Total Scans For the Past 12 Months',
                                fontSize: 24,
                            },
                            responsive:true,
                            maintainAspectRatio: false,
                        }
                        this.scanGraphLoading = false;
                    }).catch((error) => {
                        this.$emit('error');
                    });
            },
            getParcelineScanData(){
                this.scanGraphLoading = true;
                axios.get("scan-report/parcelinescanCount")
                    .then(response => {
                        this.scanGraphDataSet = {
                            labels: response.data.capacityScansLabels,
                            datasets: [
                                {
                                    label: 'Capacity Scans',
                                    data: response.data.capacityScansData,
                                    backgroundColor: 'rgb(0, 116, 217, .3)'
                                },
                                {
                                    label: 'Freight Scans',
                                    data: response.data.freightScansData,
                                    backgroundColor: 'rgb(46, 204, 64, .3)'
                                }
                            ],
                        }
                        this.scanGraphOptions = {
                            title: {
                                display: true,
                                text: 'Total Scans For the Past 12 Months',
                                fontSize: 24,
                            },
                            responsive:true,
                            maintainAspectRatio: false,
                        }
                        this.scanGraphLoading = false;
                    }).catch((error) => {
                        this.$emit('error');
                    });
            },

            getContractorData(){
                api.get('carrier/gps/contractor-schedule')
                    .then((contractorRes) => {
                        axios.get("scan-report/contractorScans")
                            .then((scanRes) => {
                                this.contractorGraphDataSet = {
                                    labels: contractorRes.data.data.labels,
                                    datasets: [
                                        {
                                            label: 'Scans by Contractor',
                                            data: this.mapContractorScans(contractorRes.data, scanRes),
                                            backgroundColor: 'rgb(46, 204, 64, .4)',
                                            borderColor: 'rgb(46, 204, 64, .8)',
                                            borderWidth: 1,
                                        },
                                        {
                                            label: 'Journeys by Contractor',
                                            data: contractorRes.data.data.data,
                                            backgroundColor: 'rgb(0, 116, 217, .2)',
                                            borderColor:  'rgb(0, 116, 217, .3)',
                                            borderWidth: 1,
                                        },
                                    ],
                                }
                                
                                this.contractorGraphOptions = {
                                    title: {
                                        display: true,
                                        text: 'Scans by Contractor Journeys this Month',
                                        fontSize: 24,
                                    },
                                    responsive:true,
                                    maintainAspectRatio: false,
                                    scales: {
                                        xAxes: [{ stacked: true }],
                                        yAxes: [{
                                                stacked: false,
                                                ticks: {
                                                beginAtZero: true,
                                                },
                                            }]
                                    }
                                }

                                this.contractorGraphLoading = false;
                            })
                            .catch((error) => {
                                this.$emit('error');
                            });
                    })
                    .catch((error) => {
                        this.$emit('error');
                    });
            },

            mapContractorScans(contractorRes, scanRes){
                let cData = [];
                contractorRes.data.labels.map(label => {
                    var index = scanRes.data.contractorLabels.indexOf(label);
                    if(index != -1){
                        cData.push(scanRes.data.contractorData[index]);
                    }else{
                        cData.push('');
                    }
                });

                return cData;
            }
        },
    };
</script>